module.exports = __webpack_public_path__ + "static/img/user_service.25342871.png";